import { localytics } from '@hcecbp/webappanalytics';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getOnBoardingAPIData, getOnBoardingAPIStatus } from '../../slices/onBoardingSlice';
import { getUserInfo } from '../../slices/userProfileSlice';
import { CAMS_BOT_USERID, EXCLUDE_USERS_DEV, EXCLUDE_USERS_PROD } from '../../constants/constants';
import { getLocalyticsAppKey } from './localytics.appkey';
import { setEnv, setOrganization, setUser, setUserRole } from './analytics.service.util';
import { appEnv } from '../properties/UrlsAndEnvProperties';
const defaultTagEventDelay = 2000;

declare global {
  interface window{
    ll:any; // localytics singleton
  }
}

declare global {
  interface window{
    ll:any; // localytics singleton
  }
}

export function AnalyticsComponent(props: {tagEventDelay?: number;}) 
{
  useAnalytics(props);
  return <div />;
}
 
export function useAnalytics({ tagEventDelay}: {tagEventDelay?: number;}) 
{
  const userOnboardAPIStatus = useSelector(getOnBoardingAPIStatus);
  const userOnboardStatus = useSelector(getOnBoardingAPIData);
  const { eid, sub } = useSelector(getUserInfo);
  const [localyticsConnectionStatus, setLocalyticsConnectionStatus] = useState(false);
  const [org, setOrg]: [string | undefined, (_?: string) => void] = useState();
  const [appEnvironment, setAppEnvironment]: [string | undefined, (_?: string) => void] = useState();

  useEffect(()=>{
    setOrg('Honeywell');
    setAppEnvironment(appEnv());
  }, []);

  useEffect(() => {   
    let appKey = getLocalyticsAppKey();
    if(userOnboardAPIStatus === 'finished' && userOnboardStatus) {
      if (userOnboardStatus.user_onboard_status === 'on-boarded' && userOnboardStatus.roles && !!sub && !!org && !!appEnvironment ) {
        let disableLocalytics = true;
        let role = userOnboardStatus.roles[0];
        let excludeUsersDevEnv = EXCLUDE_USERS_DEV.map(item => item.sub);
        let exludeUsersProdEnv = EXCLUDE_USERS_PROD.map(item => item.sub);
        if(eid.toLowerCase().includes(CAMS_BOT_USERID) || 
            (appEnvironment === 'production' && exludeUsersProdEnv.includes(sub)) || 
            (appEnvironment === 'qa' && excludeUsersDevEnv.includes(sub)) || 
            (appEnvironment === 'dev') || (appEnvironment === 'performance') || (appEnvironment === 'local')
        ){
          disableLocalytics = true;
        }
        else{
          disableLocalytics = false;
        }
        localytics.initialise(
          appKey,
          {
            sessionTimeout: 2000,
            customDimensions:[org,appEnvironment,sub,role],
            cookies: true,
            disableAnalyticsTracking: disableLocalytics
          },
          { useV3: true}
        );
        if(!disableLocalytics){
          setLocalyticsConnectionStatus(true);
        }
        else
        {
          setLocalyticsConnectionStatus(false);
        }
      }
    }
    
  },[userOnboardAPIStatus, sub, org, appEnvironment]);

  useEffect(()=>{
    if(localyticsConnectionStatus && !!sub && !!org && !!appEnvironment) {
      setUser(sub);
      setEnv(appEnvironment);
      setOrganization(org);
      userOnboardStatus && userOnboardStatus?.roles && setUserRole(userOnboardStatus.roles[0]);
    }
  },[localyticsConnectionStatus, sub, org, appEnvironment, userOnboardStatus]);
}